import React from 'react'

const hero = () => {
    return (
        <section className="h-screen">
            <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '98vw', textAlign: 'center'}}>
            <h1 className="text-center text-xl md:text-3xl font-quicksand"> I am  <span className="text-3xl md:text-5xl font-quicksand text-primary font-semibold canvas-hover"> Parag Mahale </span>  <br /> A software engineer</h1>

            <a className="p-3 m-7 inline-block border border-black font-quicksand canvas-hover" href="#about" style={{cursor: 'none'}}> About me </a>
            <a className="p-3 m-7 inline-block border border-black font-quicksand canvas-hover" href="https://drive.google.com/file/d/16Z4_Hp6ut0SsEjO4pjMd3jjRkEl7CWgj/view?usp=sharing" style={{cursor: 'none'}}> Resume </a>
        </div>
        </section>

    )
}

export default hero
